import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalStyle from "./GlobalStyles";
import Routes from "./routers";
import { AuthProvider } from "./hooks/AuthContext";
import { LanguageProvider } from "./hooks/LanguageContext";
import { ConfigProvider } from "antd";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#F4a4BF",
            },
          }}
        >
          <GlobalStyle />
          <Routes />
          <ToastContainer autoClose={3000} />
        </ConfigProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
